<template>
    <div class="animate-pulse">
        <div class="pt-2 mb-2 mt-6">
            <div class="bg-white p-6">
                <div class="h-10 w-full rounded bg-gray-200" />
                <div class="flex items-center justify-between mt-16 bg-white">
                    <div class="w-1/3">
                        <div class="h-10 mr-6 rounded bg-gray-200" />
                    </div>
                    <div class="w-1/3">
                        <div class="h-10 mx-6 rounded bg-gray-200" />
                    </div>
                    <div class="w-1/3">
                        <div class="h-10 ml-6 rounded bg-gray-200" />
                    </div>
                </div>
            </div>
            <div class="h-18" />
            <div class="bg-white p-6">
                <div class="h-10 w-full rounded bg-gray-200" />
                <div class="grid grid-cols-4 w-full rounded mt-12">
                    <div class="col-span-3 bg-gray-100 h-screen-50" />
                    <div class="bg-gray-200 h-screen-50" />
                </div>
                <div class="h-40 w-full rounded bg-white my-8" />
            </div>
        </div>
    </div>
</template>

<script>
    export default {};
</script>
